import React from "react";
import Nav from "@/components/site/Nav";
import Hero from "@/components/site/Hero";
import StrengthSystem from "@/components/site/StrengthSystem";
import FocusPoints from "@/components/site/FocusPoints";
import ShoppingJourney from "@/components/site/ShoppingJourney";
import ProductGallery from "@/components/site/ProductGallery";
import Footer from "@/components/site/Footer";
import useSEO from "@/hooks/useSEO";

export default function Landing() {
  useSEO({
    title: null,
    description: "Good Eyes is a New Zealand-designed range of reading glasses. Eight styles, 30 colourways, colour-coded by strength. Made from recycled co-polyester and recycled lenses.",
    path: "/",
  });
  return (
    <div className="min-h-screen bg-white text-[color:var(--ge-navy)]" data-testid="landing-page">
      <Nav />
      <main>
        <Hero />
        <ProductGallery />
        <StrengthSystem />
        <ShoppingJourney />
        <FocusPoints />
      </main>
      <Footer />
    </div>
  );
}
